import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh', // Takes full viewport height
        textAlign: 'center',
        padding: '20px',
        boxSizing: 'border-box',
      }}
    >
      <h1 style={{ marginBottom: '20px' }}>404 - Not Found</h1>
      <p style={{ marginBottom: '10px' }}>Please contact your adminstrator for login url.</p>
    </div>
  );
};

export default NotFound;
